import React from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import { reset } from '../features/account/slice'
import { isNotAllowed, notAllowedText } from '../utils'
import auth from '../utils/auth'
import { isHTML } from '../utils/error-checker'
import { ButtonSecondary } from './buttons'
import { Container } from './container'
import { Loader } from './loader'

const Section = ({children}) => {
  return <Container className="text-center py-5 lg:py-10">{children}</Container>
}

const RenderedHTML = ({data}) => {
  const html = data.substring(1, data.length-1).split(/\r?\n/).join('')
  return (
    <iframe srcDoc={html} title="RenderedHTMLIframe" className="w-full h-64"></iframe>
    // <div className="prose" dangerouslySetInnerHTML={{__html: html}} />
  )
}

const RetryButton = ({notAllowed, fetcher = () => {}, text = 'Retry'}) => {
  const history = useHistory()

  return (
    <div className="w-full lg:w-3/12 mx-auto">
      {
        notAllowed ? (
          <ButtonSecondary onClick={() => history.push('/login')}>
            Sign In
          </ButtonSecondary>
        ) : (
          <ButtonSecondary onClick={fetcher}>
            {text}
          </ButtonSecondary>
        )
      }
    </div>
  )
}

const StatusHandler = ({status, error, onRetry, children}) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const token = auth().getTokenFromLocalStorage()

  const notAllowed = isNotAllowed(error) && !token

  const isTimeout = error && error.includes('timeout')
  const timeoutText = 'Failed to load data. Please try again.'

  const isExpired = error && error.includes('has expired')

  const errorRendered = notAllowed ? notAllowedText
    : isTimeout ? timeoutText
    : (
      isHTML(error) ? <RenderedHTML data={error}/> : error
    )

  const handleSignOut = () => {
    toast.error("Your session is ended. Please re-login.")
    dispatch(reset())
    auth().logout()
    history.push('/login')
  }

  if(isExpired){
    return handleSignOut()
  }

  return (status === 'idle') ? (
    <Section>
      <div className="text-gray-600 mb-4">
        Need to fetch some data.
      </div>
      <RetryButton
        notAllowed={notAllowed}
        fetcher={onRetry}
        text={`Fetch`}
      />
    </Section>
  ) : (status === 'loading') ? (
    <Section>
      <Loader />
    </Section>
  ) : (status === 'succeeded') ? (
    children
  ) : (status === 'failed') ? (
    <Section>
      <div className="mb-4">
        {errorRendered}
      </div>
      <RetryButton
        notAllowed={notAllowed}
        fetcher={onRetry}
        text={`Retry`}
      />
    </Section>
  ) : (status === 'succeeded') ? (
    children
  ) : <Section>
    <p className="text-gray-600">
      Something went wrong.<br />(System Status: {String(status)})
    </p>
  </Section>
}

export { StatusHandler }
